import { formatDate } from '@akerolabs/akero-vue/src/filters/date'

/**
 * @description returns formatted date used on all tables
 * @param {Date} date
 * @return {String}
 */
export function displayDate(date) {
  if (!date) return '-'
  return formatDate(date, 'DD/MM/YY')
}

/**
 * @description Checks if value is there and returns '-' if not
 * @param {String|Number} value
 * @returns
 */
export function displayField(value) {
  if (value === undefined || value === null) return '-'
  return value
}

/**
 * @description Updates the url with the current tab to allow for reloading
 * @param {String} tab
 */
export function setTabHistory(tab) {
  const url = window.location.href.split('?')[0]
  window.history.replaceState(null, null, `${url}?tab=${tab}`)
}

/**
 * @description Gets the 'tab' from the url search to allow tab to reload on previous one after refresh
 * @return {Number}
 */
export function getTab() {
  const tabs = {
    requests: 0,
    approved: 1,
    rejected: 2,
    processed: 3,
  }
  if (!window || !window.location) return 0
  const query = new URLSearchParams(window.location.search)
  const search = {}
  for (const pair of query.entries()) {
    search[pair[0]] = pair[1]
  }
  if (Object.prototype.hasOwnProperty.call(tabs, search.tab)) {
    return tabs[search.tab]
  }
  return 0
}
